import { atom } from "jotai";

import type { BrandQuery } from "~/graphql/graphql.gen";
import type { Address } from "~/utils/address";

export const serverTimeState = atom<Date | undefined>(undefined);

export type Brand =
  | (Omit<
      NonNullable<BrandQuery["brand"]>,
      "address" | "bank_address" | "return_address"
    > & {
      // TODO: Type retrieved from the API - type the address object on the back-end
      billing_address?: Address | null;
      bank_address?: Address | null;
      return_address?: Address | null;
      nbUsers?: number;
    })
  | undefined;

export const brandState = atom<Brand>(undefined);
